import { CustomRoute } from '@app/components/layout/sidebar/components/route';
import VerifyEmailPage from '@app/onboarding/email-verification/verify-email-page';
import SignupPage from '@app/onboarding/signup/signup-page';
import { Route } from 'react-router-dom';
import AuthLayout from './auth-layout';
import ForgotPasswordPage from './pages/forgot-password-page';
import LoginPage from './pages/login-page';
import PasswordResetPage from './pages/password-reset-page';

export const authRoutes = {
  FORGOT_PASSWORD: '/password/forgot',
  PASSWORD_RESET: '/password/change/:uid/:token',
  LOGIN: '/login',
  SIGNUP: '/sign-up',
  VERIFY_EMAIL: '/verify-email/:key',
};

export function AuthRoutes() {
  return (
    <Route
      element={
        <CustomRoute
          element={<AuthLayout />}
          hasSidebar={false}
          requiresAuth={false}
        />
      }
    >
      <Route
        path={authRoutes.FORGOT_PASSWORD}
        element={<ForgotPasswordPage />}
      />
      <Route path={authRoutes.PASSWORD_RESET} element={<PasswordResetPage />} />
      <Route path={authRoutes.LOGIN} element={<LoginPage />} />
      <Route path={authRoutes.SIGNUP} element={<SignupPage />} />
      <Route path={authRoutes.VERIFY_EMAIL} element={<VerifyEmailPage />} />
    </Route>
  );
}
